import { SwivelAnimation } from "./swivelAnimation";
// Generic swivel animation initializer that any product can use
export function swivel(preview, range, damping, tags) {
  const swivelOptions = {
    range,
    damping: damping !== null && damping !== void 0 ? damping : false,
    tags: tags !== null && tags !== void 0 ? tags : []
  };
  const animation = new SwivelAnimation(preview.getProductGeometry, swivelOptions);
  return preview.pushAnimation(animation).start();
}